import * as Highcharts from 'highcharts';

export function initHighcharts() {
  // FIXME: ICe: prozkoumat jestli neexistuje lepsi zpusob jak povolit atributy/tagy
  const allowedAttributes = [
    'data-event-type',
    'data-ext',
    'data-size',
    'data-pos',
    'data-dev',
    'data-zeroed',
    'data-over',
    'data-positioned',
    'data-reactroot',
    'data-focusable',
    'data-event',
    'data-event-id',
    'data-total',
    'data-chart-overflow',
    'data-tooltip-overflow',
    'data-debug',
    'viewBox',
    'focusable',
    'stroke-miterlimit',
    'stroke-linejoin',
    'transform',
    'rx',
  ];
  const allowedTags = [
    'g',
  ];

  allowedAttributes.forEach(attr => Highcharts.AST.allowedAttributes.push(attr));
  allowedTags.forEach(tag => Highcharts.AST.allowedTags.push(tag));

  Highcharts.AST.allowedReferences.push('data:')

  Highcharts.setOptions({
    accessibility: {
      enabled: false, // FIXME: ICe: cilem ale je doporucovany accessibility modul pouzit
    },
  });
}
